export default {
    din_alternatebold: "din_alternatebold"
}